import request from '@/CommonDP/utils/request';
// 协作图层维护
export default {
  // 列表
  getcollaborationLayerList(params) {
    return request
      .get(`/collaborationLayer/list-collaboration-layer`, {
        params
      })
      .then((res) => res);
  },
  // 更新图层选择状态
  updateCollaborationLayerStatus(params) {
    return request
      .post(`/collaborationLayer/update-layer-status`, params)
      .then((res) => res);
  },
  batchUpdateCollaborationLayerStatus(params) {
    return request
      .post(`/collaborationLayer/batch-update-layer-status`, params)
      .then((res) => res);
  }
};
